export const ATTR_WATERFALL_ELEMENT = "waterfall-el";
// Pagination
export const EL_PAGINATION = "pagination";
export const EL_PAGINATION_BULLET = "pagination-bullet";
export const EL_PAGINATION_BULLET_ACTIVE = "pagination-bullet-active";
// Navigation
export const EL_NAVIGATION = "waterfall-navigation";
export const EL_NAVIGATION_NEXT = "navigation-next";
export const EL_NAVIGATION_PREV = "navigation-prev";
// Scrollbar
export const EL_SCROLLBAR = "scrollbar";
export const EL_SCROLLBAR_DRAG = "scrollbar-drag";
// Slide Count
export const EL_SLIDE_COUNT = "slide-count";
